import { render, staticRenderFns } from "./Reports_Dashboard.vue?vue&type=template&id=58dc9dc5&scoped=true"
import script from "./Reports_Dashboard.vue?vue&type=script&lang=js"
export * from "./Reports_Dashboard.vue?vue&type=script&lang=js"
import style0 from "./Reports_Dashboard.vue?vue&type=style&index=0&id=58dc9dc5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dc9dc5",
  null
  
)

export default component.exports